export const columnSize: { [key: string]: { flex: number; minWidth: number; width: number } } = {
  large: {
    flex: 3,
    minWidth: 200,
    width: 200,
  },
  medium: {
    flex: 2,
    minWidth: 120,
    width: 120,
  },
  small: {
    flex: 1,
    minWidth: 80,
    width: 80,
  },
  standard: {
    flex: 1.5,
    minWidth: 100,
    width: 100,
  },
  xLarge: {
    flex: 4,
    minWidth: 250,
    width: 250,
  },
};

export const getColumnSize = (size: string | undefined = 'medium') => {
  return columnSize[size];
};
